// extracted by mini-css-extract-plugin
module.exports = {"page":"PrivacyPolicy_page__fzG2F","page--generic":"PrivacyPolicy_page--generic__Vq6cT","anchor":"PrivacyPolicy_anchor__CnD_1"};